import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { getFirstAvailableRoute } from 'utils/routing';

const NavigateToFirstAvailablePage = () => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth.auth);
    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);
    const { isGuestPassIntegrated, isTokenValid } = useSelector((state: RootState) => state.integration);

    const tokenScopeList = useMemo(
        () => auth.data?.[0]?.tokenScopeList || [],
        [auth.data]
    );

    useEffect(() => {
        if (!orgId || tokenScopeList.length === 0) return;

        const route = getFirstAvailableRoute(tokenScopeList, orgId, isGuestPassIntegrated, isTokenValid);
        navigate(route, { replace: true });
    }, [tokenScopeList, orgId, isGuestPassIntegrated, isTokenValid, navigate]);

    return null;
};

export default NavigateToFirstAvailablePage;
